<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="row">
                    <div class="col-md-4">
                        <router-link
                            :to="{ name: 'User-listing' }"
                            class="card shadow-lg card-border-radius-20 card-height-220"
                        >
                            <div class="card-body d-flex justify-content-center align-items-center">
                                <h3 class="font-weight-bold">{{ $t('module.user') }}</h3>
                            </div>
                        </router-link>
                    </div>
                    <div class="col-md-4">
                        <router-link
                            :to="{ name: 'Password-reset-listing' }"
                            class="card shadow-lg card-border-radius-20 card-height-220"
                        >
                            <div class="card-body d-flex justify-content-center align-items-center">
                                <h3 class="font-weight-bold">{{ $t('module.passwordReset') }}</h3>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";

export default {
    page: {
        title: i18n.t("module.other"),
    },
    components: { Layout, PageHeader },
    data() {
        return {
            title: i18n.t("module.other"),
            items: [
                {
                    text: i18n.t("module.other"),
                    active: true,
                },
            ],
        }
    }
}
</script>
